import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  apiError,
  getProblemList,
  problemListSuccessful,
  addProblemSuccessful,
  problemDocSuccessful,
  problemCheckApproveSuccessful,
  isRejectModelVisible,
  problemTypeDropdownSuccessful,
  vehicleListSuccessful,
  customerListSuccessful,
  hpNumberListSuccessful,
  serviceTypeDropdownSuccessful,
  problemApproveDocSuccessful,
  hpNumberDocSuccessful,
} from "./problemSlice";
import { Modal } from "antd";
import { RiCheckboxCircleLine, RiAlertLine } from "react-icons/ri";
import {
  getParamsList,
  getList,
  postAdd,
  postEdit,
  postDelete,
  postMultipartFormData,
  putMultipartFormData,
} from "../../../helpers/Helper";

function* fetchProblemList({ payload }) {
  var params = {};
  for (const k in payload) {
    if (Object.hasOwnProperty.call(payload, k)) {
      if (payload[k] != "" && k != null && k != "no_of_pages") {
        params[k] = payload[k];
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/problem/list/", params);
    yield put(problemListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* fetchProblemApprovalList({ payload }) {
  var params = {};
  for (const k in payload) {
    if (Object.hasOwnProperty.call(payload, k)) {
      if (payload[k] != "" && k != null && k != "no_of_pages") {
        params[k] = payload[k];
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/problem/approve/list/", params);
    yield put(problemListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AddProblem({ payload }) {
  try {
    const formData = new FormData();
    formData.append("problem_type_id", payload.problem_type_id);
    formData.append("priority", payload.priority);
    if (payload.remarks) formData.append("remarks", payload.remarks);
    if (payload.service_type_id)
      formData.append("service_type_id", payload.service_type_id);
    if (payload.date) formData.append("date", payload.date);
    if (payload.vehicle_id) formData.append("vehicle_id", payload.vehicle_id);
    if (payload.customer_id)
      formData.append("customer_id", payload.customer_id);
    if (payload.hp_no) formData.append("hp_no", payload.hp_no);
    if (payload.others) formData.append("others", payload.others);
    if (payload.file && payload.file.originFileObj) {
      formData.append("file", payload.file.originFileObj);
    }

    if (payload.id == 0) {
      const response = yield call(
        postMultipartFormData,
        "/problem/create/",
        formData,
      );
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: (
            <p className="hp-p1-body hp-text-color-black-80">
              Problem Added Successfully!
            </p>
          ),
        });
        yield put(addProblemSuccessful());
        return response;
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <p className="hp-p1-body hp-text-color-black-80">
              Unable to add Problem!
            </p>
          ),
        });
      }
    } else {
      const response = yield call(
        putMultipartFormData,
        "/problem/" + payload.id,
        formData,
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: (
            <p className="hp-p1-body hp-text-color-black-80">
              Problem Updated Successfully!
            </p>
          ),
        });
        yield put(addProblemSuccessful());
        return response;
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <p className="hp-p1-body hp-text-color-black-80">
              Unable to update Problem!
            </p>
          ),
        });
      }
    }
    yield put(addProblemSuccessful());
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <p className="hp-p1-body hp-text-color-black-80">Server side issue!</p>
      ),
    });
    yield put(apiError(error));
  }
}

function* fetchProblemDoc({ payload }) {
  try {
    const response = yield call(getList, "/problem/" + payload);
    yield put(problemDocSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* checkProblemApprove({ payload }) {
  try {
    const response = yield call(
      getParamsList,
      "/problem/approve/check/",
      payload,
    );
    yield put(problemCheckApproveSuccessful(true));
  } catch (error) {
    yield put(problemCheckApproveSuccessful(false));
  }
}

function* ProblemApproval({ payload }) {
  try {
    const response = yield call(postAdd, "/problem/approve/create/", payload);
    if (response.status === 200 || response.status === 201) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: (
          <p className="hp-p1-body hp-text-color-black-80">
            {payload.approvalstatus == 2
              ? "Problem Approved!"
              : "Problem Rejected!"}
          </p>
        ),
      });
      yield put(isRejectModelVisible(false));
      // Reload the doc and approve data
      yield put({ type: "problem/getProblemDoc", payload: payload.problem_id });
      yield put({
        type: "problem/getProblemApproveDoc",
        payload: payload.problem_id,
      });
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <p className="hp-p1-body hp-text-color-black-80">Action failed!</p>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <p className="hp-p1-body hp-text-color-black-80">Server side issue!</p>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteProblem({ payload }) {
  try {
    const response = yield call(postDelete, "/problem/" + payload);
    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: (
          <p className="hp-p1-body hp-text-color-black-80">Problem deleted!</p>
        ),
      });
      yield put(getProblemList({ page: 1, search: "", page_size: 10 }));
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* fetchProblemTypeDropdown({ payload }) {
  try {
    const response = yield call(
      getParamsList,
      "/masters/problemtypes/",
      payload,
    );
    yield put(problemTypeDropdownSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* fetchVehicleList({ payload }) {
  try {
    const response = yield call(getParamsList, "/masters/vehicles/", payload);
    yield put(vehicleListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* fetchCustomerList({ payload }) {
  try {
    const response = yield call(getParamsList, "/masters/person/list", {
      ...payload,
      ordering: "-code",
    });
    yield put(customerListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* fetchHpNumberList({ payload }) {
  try {
    const response = yield call(getParamsList, "/sale/finance-ovf/", payload);
    yield put(hpNumberListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* fetchHpNumberDoc({ payload }) {
  try {
    const response = yield call(getList, "/sale/finance-ovf/" + payload + "/");
    yield put(hpNumberDocSuccessful(response));
  } catch (error) {
    yield put(hpNumberDocSuccessful({}));
  }
}

function* fetchServiceTypeDropdown({ payload }) {
  try {
    const response = yield call(
      getParamsList,
      "/masters/servicetypes/",
      payload,
    );
    yield put(serviceTypeDropdownSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

export function* watchGetProblemList() {
  yield takeEvery("problem/getProblemList", fetchProblemList);
}
export function* watchGetProblemApprovalList() {
  yield takeEvery("problem/getProblemApprovalList", fetchProblemApprovalList);
}
export function* watchAddProblem() {
  yield takeEvery("problem/addProblem", AddProblem);
}
export function* watchGetProblemDoc() {
  yield takeEvery("problem/getProblemDoc", fetchProblemDoc);
}
export function* watchProblemCheckApprove() {
  yield takeEvery("problem/getProblemCheckApprove", checkProblemApprove);
}
export function* watchProblemApproval() {
  yield takeEvery("problem/problemApproval", ProblemApproval);
}
export function* watchProblemDelete() {
  yield takeEvery("problem/problemDelete", DeleteProblem);
}
export function* watchProblemTypeDropdown() {
  yield takeEvery("problem/getProblemTypeDropdown", fetchProblemTypeDropdown);
}
export function* watchGetVehicleList() {
  yield takeEvery("problem/getVehicleList", fetchVehicleList);
}
export function* watchGetCustomerList() {
  yield takeEvery("problem/getCustomerList", fetchCustomerList);
}
export function* watchGetHpNumberList() {
  yield takeEvery("problem/getHpNumberList", fetchHpNumberList);
}
export function* watchGetHpNumberDoc() {
  yield takeEvery("problem/getHpNumberDoc", fetchHpNumberDoc);
}
export function* watchServiceTypeDropdown() {
  yield takeEvery("problem/getServiceTypeDropdown", fetchServiceTypeDropdown);
}

function* fetchProblemApproveDoc({ payload }) {
  try {
    const response = yield call(getList, "/problem/approve/" + payload);
    yield put(problemApproveDocSuccessful(response));
  } catch (error) {
    yield put(problemApproveDocSuccessful({}));
  }
}
export function* watchGetProblemApproveDoc() {
  yield takeEvery("problem/getProblemApproveDoc", fetchProblemApproveDoc);
}

function* ProblemSaga() {
  yield all([
    fork(watchGetProblemList),
    fork(watchGetProblemApprovalList),
    fork(watchAddProblem),
    fork(watchGetProblemDoc),
    fork(watchProblemCheckApprove),
    fork(watchProblemApproval),
    fork(watchProblemDelete),
    fork(watchProblemTypeDropdown),
    fork(watchGetVehicleList),
    fork(watchGetCustomerList),
    fork(watchGetHpNumberList),
    fork(watchGetHpNumberDoc),
    fork(watchServiceTypeDropdown),
    fork(watchGetProblemApproveDoc),
  ]);
}

export default ProblemSaga;
